import { useQuery } from '@tanstack/react-query';

import axios, { parseAxiosError } from '@/portainer/services/axios/axios';
import { withError } from '@/react-tools/react-query';

import { buildUrl } from './backupSettings.service';
import { queryKeys } from './queryKeys';

export interface BackupLocalStatus {
  failed: boolean;
  timestampUTC: string;
  path: string;
}

export function useBackupLocalStatus({ enabled }: { enabled?: boolean } = {}) {
  return useQuery(queryKeys.backupLocalStatus(), getBackupLocalStatus, {
    enabled,
    ...withError('Unable to retrieve local backup status'),
  });
}

async function getBackupLocalStatus() {
  try {
    const { data } = await axios.get<BackupLocalStatus>(
      buildUrl('local', 'status')
    );

    return data;
  } catch (e) {
    throw parseAxiosError(e as Error, 'Unable to retrieve local backup status');
  }
}
